<script setup lang="ts">
import { onMounted, watch } from 'vue'
import AppShell from './shell/AppShell.vue'
import OverlayHost from './overlays/OverlayHost.vue'
import { loadLearning, resetLearning } from './stores/learning'
import { loadSession, session } from './stores/session'
import { importLegacyLearning } from './legacy-import'

onMounted(async () => {
  if (!session.loaded) await loadSession()
  await loadLearning()
})
// Progress follows the account: refetch after sign-in or sign-out.
watch(() => session.user?.id, id => {
  resetLearning()
  void loadLearning(true)
  // One-time bridge for browser records left by the legacy web app; failure is retried next visit.
  if (id) void importLegacyLearning(id)
})
</script>

<template>
  <AppShell>
    <RouterView />
  </AppShell>
  <OverlayHost />
</template>
